import React from "react";
import { Form } from "react-bootstrap";
import { useGetTemplatesQuery } from "../../../../../services/api/repositories/TemplateMailsRepository";

function TemplateInput({tabIndex, template, setTemplate, templateValidationError, templateIsSetByUser, setTemplateIsSetByUser}:
    {tabIndex: number, template: string, setTemplate: (template: string) => void, templateValidationError: string, templateIsSetByUser: boolean, setTemplateIsSetByUser: (templateIsSetByUser: boolean) => void}){
    
        const templatesQuery = useGetTemplatesQuery({disabled_pagination: true});

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setTemplate(event.target.value);

        if (setTemplateIsSetByUser) {
            setTemplateIsSetByUser(false);
        }
    }

    return (
        <Form.Group  className="form-group template required">
            <Form.Label className="form-label" htmlFor="mailing-email-template-select">Template</Form.Label>
            <p className="form-help">Le Template email est le modèle de contenu qui sera envoyé au destinataire dans le cadre de cette configuration d'envoi.</p>
            <Form.Select 
                className="form-select" 
                id="mailing-email-template-select" 
                tabIndex={tabIndex} 
                required 
                value={template || "none"}
                onChange={handleChange}
                isInvalid={templateValidationError !== null && templateIsSetByUser}
            >
                <option value="none" disabled>Sélectionner un Template email</option>
                {templatesQuery.isLoading && <option>Chargement...</option>}
                {!templatesQuery.isLoading && (
                    <>
                        {templatesQuery.data && "templates" in templatesQuery.data && templatesQuery.data.templates && 
                            templatesQuery.data.templates.map(template => <option key={template.uuid} value={template.uuid}>{template.name}</option>)
                        }
                    </>
                )}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{templateValidationError}</Form.Control.Feedback>
        </Form.Group >
    );
}

export default TemplateInput;